import { action } from 'typesafe-actions';
import { InsightsTypes, InsightItem } from './types';

export const generateRequest = (dateFrom?: string, dateTo?: string) =>
  action(InsightsTypes.GENERATE_REQUEST, { dateFrom, dateTo });

export const generateSuccess = (insight: InsightItem) =>
  action(InsightsTypes.GENERATE_SUCCESS, { insight });

export const generateFailure = (error: string) =>
  action(InsightsTypes.GENERATE_FAILURE, { error });

export const listRequest = (page?: number) =>
  action(InsightsTypes.LIST_REQUEST, { page: page || 1 });

export const listSuccess = (data: { insights: InsightItem[]; total: number; page: number; totalPages: number }) =>
  action(InsightsTypes.LIST_SUCCESS, data);

export const listFailure = () =>
  action(InsightsTypes.LIST_FAILURE);

export const selectInsight = (insight: InsightItem | null) =>
  action(InsightsTypes.SELECT_INSIGHT, { insight });
